import { makeEditorNavStore, useEditorStore } from '@diana/core';
import { useCallback } from 'react';

export interface IUseExpandItemProps {
  itemId: string;
  level: number;
}

export const useExpandItem = ({ itemId, level }: IUseExpandItemProps) => {
  const flowId = useEditorStore((s) => s.flow?.id ?? '');

  const useEditorNavStore = makeEditorNavStore(flowId);
  const updateLayoutNav = useEditorNavStore((s) => s.updateLayoutNav);
  const isExpanded = useEditorNavStore((s) => !!s.layoutNav[itemId] ?? false);

  const handleExpand = useCallback(
    (value: boolean) => updateLayoutNav({ itemId, value, level }),
    [updateLayoutNav, itemId, level],
  );

  return { isExpanded, handleExpand };
};
